import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_YEAR = 1000;
const DEFAULT_MAX_YEAR = 9999;

export const lastFundingYearDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.LAST_FUNDING_YEAR,
  name: 'Last Funding Year',
  type: FilterType.RANGE,
  min: undefined,
  max: undefined,
  isActive: false,
  isVisible: true,
};

export const lastFundingYearHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    return {
      ...currentFilterState,
      min: currentFilterState.min ?? DEFAULT_MIN_YEAR,
      max: currentFilterState.max ?? DEFAULT_MAX_YEAR,
    };
  },
};
